// extracted by mini-css-extract-plugin
export default {"root":"TabsBar_root__rz4eX","indicator":"TabsBar_indicator__74INB"};